"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var description_1 = require("./utils/description");
/**
 * Check whether value is an instance of Map
 */
function isMap(value) {
    return typeof Map !== 'undefined' && value instanceof Map;
}
exports.default = isMap;
description_1.setDescription(isMap, 'a Map');
